// components
import { Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useNonMemberAccountPage } from "containers/NonMemberAccount/useNonMemberAccountPage";
//
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

// styles
import styles from "containers/NonMemberAccount/nonMemberAccount.module.css";

// constants
import { PageTitles } from "constants/global";

const NonMemberAccountPage = () => {
	const {
		quantityGo,
		quantityAo,
		quantityAhcs,
		errorQuantityAo,
		errorQuantityGo,
		errorQuantityAhcs,
		errorMessageQuantityAo,
		errorMessageQuantityGo,
		errorMessageQuantityAhcs,
		handleQuantityAo,
		handleQuantityGo,
		handleQuantityAhcs,
		reservedCounts,
		form,
		createAccount,
		loading
	} = useNonMemberAccountPage();

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title="Non-Member Account Creation" subTitle="Create non-member accounts." />
			<div className={styles?.root}>
				<Head>{PageTitles.OFFER_UPDATE}</Head>

				<Form form={form} requiredMark={false} layout="vertical">
					<div className="grid grid-cols-2 ">
						<div className="grid grid-cols-3  mt-6 rounded-lg border-2">
							<div className={styles.headerTable} style={{ padding: "20px" }}>
								User Pool
							</div>
							<div className={`${styles.headerTable} text-center`} style={{ padding: "20px" }}>
								Current Reserve
							</div>
							<div className={styles.headerTable}>
								Quantity to Create<p>* Max 1000</p>{" "}
							</div>
						</div>
					</div>
					<div className="grid grid-cols-2">
						<div className="grid grid-cols-3 border-2 rounded-lg mt-2 ">
							<div className={styles.bodyTable}>non_member_ahcs</div>
							<div className={`${styles.bodyTable} text-center`}>{reservedCounts.non_member_ahcs}</div>
							<div className={styles.bodyTable}>
								<Form.Item
									className="mb-auto mr-1"
									name="quantityAhcs"
									initialValue={0}
									extra={errorQuantityAhcs && <ErrorMessage classes={styles?.err_message} message={errorMessageQuantityAhcs} />}
								>
									<Input
										className={`${styles?.input_field}  ${quantityAhcs ? styles?.filled : ""}`}
										placeholder=""
										type="number"
										value={quantityAhcs}
										onChange={(e) => handleQuantityAhcs(e.target.value as any)}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-2">
						<div className="grid grid-cols-3 border-2 rounded-lg mt-2">
							<div className={styles.bodyTable}>non_member_ao</div>
							<div className={`${styles.bodyTable} text-center`}>{reservedCounts.non_member_ao}</div>
							<div className={styles.bodyTable}>
								<Form.Item
									className="mb-auto mr-1"
									name="quantityAo"
									initialValue={0}
									extra={errorQuantityAo && <ErrorMessage classes={styles?.err_message} message={errorMessageQuantityAo} />}
								>
									<Input
										className={`${styles?.input_field}  ${quantityAo ? styles?.filled : ""}`}
										placeholder=""
										type="number"
										value={quantityAo}
										onChange={(e) => handleQuantityAo(e.target.value as any)}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-2">
						<div className="grid grid-cols-3 border-2 rounded-lg mt-2">
							<div className={styles.bodyTable}>non_member_go</div>
							<div className={`${styles.bodyTable} text-center`}>{reservedCounts.non_member_go}</div>
							<div className={styles.bodyTable}>
								<Form.Item
									className="mb-auto mr-1"
									name="quantityGo"
									initialValue={0}
									extra={errorQuantityGo && <ErrorMessage classes={styles?.err_message} message={errorMessageQuantityGo} />}
								>
									<Input
										className={`${styles?.input_field}  ${quantityGo ? styles?.filled : ""}`}
										placeholder=""
										type="number"
										value={quantityGo}
										onChange={(e) => handleQuantityGo(e.target.value as any)}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-2  place-items-end mt-6">
						<Button label="Proceed" onClick={createAccount} />
					</div>
				</Form>
			</div>
		</div>
	);
};

export default NonMemberAccountPage;
